import Hero from "@/components/sections/Hero";
import TrustStrip from "@/components/sections/TrustStrip";
import Problem from "@/components/sections/Problem";
import LifecycleStepper from "@/components/sections/LifecycleStepper";
import FeatureGrid from "@/components/sections/FeatureGrid";
import AICapabilities from "@/components/sections/AICapabilities";
import RoleTabs from "@/components/sections/RoleTabs";
import Reporting from "@/components/sections/Reporting";
import Customization from "@/components/sections/Customization";
import FieldApp from "@/components/sections/FieldApp";
import Integrations from "@/components/sections/Integrations";
import Security from "@/components/sections/Security";
import ROICalculator from "@/components/sections/ROICalculator";
import Pricing from "@/components/sections/Pricing";
import DemoForm from "@/components/sections/DemoForm";

export default function Home() {
  return (
    <>
      <Hero />
      <TrustStrip />
      <Problem />
      <LifecycleStepper />
      <FeatureGrid />
      <AICapabilities />
      <RoleTabs />
      <Reporting />
      <Customization />
      <FieldApp />
      <Integrations />
      <Security />
      <ROICalculator />
      <Pricing />
      <section id="demo" data-testid="home-demo-section" className="section-y relative">
        <div className="container-x">
          <div className="max-w-3xl reveal mb-10 text-center mx-auto">
            <div className="text-xs font-mono uppercase tracking-[0.2em] text-[#F97316] mb-3">Request Demo</div>
            <h2 className="font-display font-extrabold text-3xl sm:text-4xl lg:text-5xl text-white tracking-tight">
              See how LocateOS can modernize your locate operations.
            </h2>
            <p className="mt-5 text-lg text-[#94A3B8]">
              We'll show you the platform, answer your questions, and map it to your specific workflows.
            </p>
          </div>
          <div className="reveal">
            <DemoForm />
          </div>
        </div>
      </section>
    </>
  );
}
